class TempVerifyRequest {
    TempVerifyURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerify/"+trx
    }

    TempVerifyBkashURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerifyBkash/"+trx
    }
}
export const {TempVerifyURL, TempVerifyBkashURL}=new TempVerifyRequest();